import React from 'react'

const Logo = require('../../assets/img/fh-logo.png')

const Nav = () => (
  <header>
    <nav className="nav">
      <div className="container">
        <div className="nav-left">
          <a href="https://www.myfarmhand.com" className="nav-item">
            <img src={Logo} alt="Farmhand logo" />
          </a>
        </div>

        <div className="nav-right">

          <div className="nav-item">
            <p className="control">
              <a href="/dashboard" className="button is-primary is-small is-outlined">
                <span>log in</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </nav>
  </header>
)

export default Nav



// WEBPACK FOOTER //
// ./components/Nav.js